<template>
	<div class="detail">
		<div class="menu-wp"></div>
		<div class="erji-content pp50">
			<div class="container">
				<div class="danpian">
					<div class="danpian-h1">{{content.title}}</div>
					<div class="danpian-h2">{{content.created_at.slice(0,10)}} &nbsp 浏览量：{{content.hit}}</div>
					<div class="danpian-con" v-html="content.body">
						
					</div>
					<div class="dan-page">
						<div class="dan-a tver fl" v-if="content.pre_id">上一篇：<span @click="go_pnLink(content.pre_id)">{{prev_title}}</span></div>
						<div class="dan-a tver fr" v-if="content.next_id">下一篇：<span @click="go_pnLink(content.next_id)">{{next_title}}</span></div>
						<div class="clear"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'detail',
		data(){
			return{
				content:{
					title:'',
					created_at:'',
					hit:'',
					body:''
				},
				prev_title:'',
				next_title:'',
			}
		},
		methods:{
			res_detail(e){
				this.axios.get('/api/news/newsView?id=' + e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.content = response.data.reslut;
							this.content.body = response.data.reslut.body.replace(
								/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
								(match, path) => {
									return path.search("http") == -1
										? `<img src='${this.icoURL}/${path}' />`
										: match;
								}
							);
						}
						this.res_prev();
						this.res_next();
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			res_prev(){
				if(this.content.pre_id != '' && this.content.pre_id != null){
					this.axios.get('/api/news/newsView?id='+this.content.pre_id)
						.then(response => {
							// 处理成功情况
							if(response.data.code == 200){
								// console.log(response.data.reslut)
								this.prev_title = response.data.reslut.title;
							}else{
								this.prev_title = ''
							}
						})
						.catch(error => {
							// 处理错误情况
							console.log(error);
						})
				}else{
					console.log('上一篇没了')
				}
			},
			res_next(){
				if(this.content.next_id != '' && this.content.next_id != null){
					this.axios.get('/api/news/newsView?id='+this.content.next_id)
						.then(response => {
							// 处理成功情况
							if(response.data.code == 200){
								// console.log(response.data.reslut)
								this.next_title = response.data.reslut.title;
							}else{
								this.next_title = ''
							}
						})
						.catch(error => {
							// 处理错误情况
							console.log(error);
						})
				}else{
					console.log('下一篇没了')
				}
			},
			//跳转兄弟链接
			go_pnLink(e){
				$('html, body').animate({ scrollTop: 0 }, 0);
				if(e){
					this.$router.push({
						path:'/detail',
						query:{
							id:e
						}
					})	
					console.log('===')
				}else{
					console.log('???')
				}
			}
		},
		watch :{
			'$route' (to, from) {
					// 对路由变化作出响应...
					// console.log("to",to);
					// console.log("from",from);
					this.prev_title= "";
					this.next_title= "";
					this.res_detail(to.query.id);
			}
		},
		created() {
			this.res_detail(this.$route.query.id);
		}
	}
</script>

<style>
</style>